// extracted by mini-css-extract-plugin
export default {"container":"Profit_container__O3qui","highlight":"Profit_highlight__iNVZw"};